
import React from "react";

type Mention = {
  id: string;
  type: string;
  name: string;
};

interface MentionListProps {
  mentions: Mention[];
  onSelect: (mention: Mention) => void;
}

export const MentionList: React.FC<MentionListProps> = ({ mentions, onSelect }) => {
  return (
    <div className="absolute bottom-full left-0 mb-2 w-64 bg-white rounded-lg shadow-lg border overflow-hidden z-10">
      {mentions.length === 0 ? (
        <div className="p-4 text-gray-500 text-sm">No matches found</div>
      ) : (
        <ul className="max-h-64 overflow-y-auto">
          {mentions.map((mention) => (
            <li 
              key={mention.id}
              onClick={() => onSelect(mention)}
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center"
            >
              <div className={`w-2 h-2 rounded-full mr-2 ${mention.type === 'product' ? 'bg-blue-500' : 'bg-green-500'}`} />
              <div>
                <div className="font-medium">{mention.name}</div>
                <div className="text-xs text-gray-500 capitalize">{mention.type}</div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
